
import { defineComponent, computed, PropType } from 'vue'
import moment, { Moment, DurationInputArg1, DurationInputArg2 } from 'moment'
import { RESOLUTIONS, TIME_UNITS } from '@/lib/constants'
import { now } from '@/lib/time'

const PREV_LABELS = {
  [RESOLUTIONS.TEN_MIN]: '10分前',
  [RESOLUTIONS.HOURLY]: '1時間前',
  [RESOLUTIONS.DAILY]: '前日',
}

const NEXT_LABELS = {
  [RESOLUTIONS.TEN_MIN]: '10分後',
  [RESOLUTIONS.HOURLY]: '1時間後',
  [RESOLUTIONS.DAILY]: '翌日',
}

const TODAY_LABELS = {
  [RESOLUTIONS.TEN_MIN]: '現在時刻',
  [RESOLUTIONS.HOURLY]: '現在時刻',
  [RESOLUTIONS.DAILY]: '今日',
}

const SPANS = {
  [RESOLUTIONS.TEN_MIN]: 10,
  [RESOLUTIONS.HOURLY]: 1,
  [RESOLUTIONS.DAILY]: 1,
}

export default defineComponent({
  props: {
    resolution: {
      type: String,
      default: RESOLUTIONS.HOURLY,
    },
    modelValue: {
      type: Object as PropType<Moment>,
      default: new Date(),
    },
  },

  setup(props, { emit }) {
    const prevLabel = computed(() => PREV_LABELS[timeSeekerResolution.value])
    const todayLabel = computed(() => TODAY_LABELS[timeSeekerResolution.value])
    const nextLabel = computed(() => NEXT_LABELS[timeSeekerResolution.value])

    const move = (tag: string) => {
      const span = SPANS[timeSeekerResolution.value] as DurationInputArg1
      const unit = TIME_UNITS[timeSeekerResolution.value] as DurationInputArg2

      if (!span || !unit) {
        return
      }

      if (tag === 'today') {
        emit('update:modelValue', now(props.resolution))
      } else if (tag === 'prev') {
        emit('update:modelValue', moment(props.modelValue).add(-span, unit))
      } else {
        emit('update:modelValue', moment(props.modelValue).add(span, unit))
      }
    }

    // 10分の場合も１時間単位で移動
    const timeSeekerResolution = computed(() => {
      return props.resolution === RESOLUTIONS.TEN_MIN ? RESOLUTIONS.HOURLY : props.resolution
    })

    return {
      prevLabel,
      todayLabel,
      nextLabel,
      move,
      timeSeekerResolution,
    }
  },
})
